<template>
  <div class="d-flex col-12 col-md-auto px-0 mb-3 mb-md-2">
    <div class="filter">
      <div class="form-check pl-0">
        <input
          class="form-check-input"
          type="radio"
          name="reportsMode"
          id="reportsModeIncoming"
          value="incoming"
          :checked="active === 'incoming'"
          @change="$router.push({ path: '/reports/incoming', query: $route.query })"
        />
        <label class="form-check-label" for="reportsModeIncoming">Incoming money</label>
      </div>
      <div class="form-check pl-0">
        <input
          class="form-check-input"
          type="radio"
          name="reportsMode"
          id="reportsModeOutgoing"
          value="outgoing"
          :checked="active === 'outgoing'"
          @change="$router.push({ path: '/reports/outgoing', query: $route.query })"
        />
        <label class="form-check-label" for="reportsModeOutgoing">Outgoing money</label>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ReportsToggle',
  props: {
    active: { type: String, default: 'incoming' }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Reports/ReportsToggle.vue